module.exports = __webpack_public_path__ + "static/52437fad09fdda4d1b93f2eef0c1526f18659f7d8536b0ac30ce86c8e0cddad5-f9cfb985fdf75923454f6320c3630a15.png";